import styled from "styled-components";

import { singleSelectDDContentStyles } from "app/pages/sales-intelligence/common-components/dropdown/styles";

export const StyledDropdownParent = styled.div`
    position: relative;
    top: 3px;
    min-width: 0;

    & .DropdownContent-container {
        ${singleSelectDDContentStyles};
    }
`;
